import defaultConfig, { LEFT, RIGHT } from '../default/config_default';
import { cloneDeep } from 'lodash';

let page = cloneDeep(defaultConfig);

page.imageSrc = 'background/strona_048.jpg';
page.paint = [
  {
    id: 'page024_game3',
    icon: 'ikona_cw3',
    // tooltip: "Zaprogramuj animację (Scratch).",
    // tooltip: "page000_test24 TrInputOnBackgroundJims08",
    paintObj: {
      text: 'Przesuń rysunek i go pokoloruj.  ',
      audio: 'files/page024/z24c3.mp3',
      item: {
        path: 'informatyka/files/page024/z.24cw.3.bmp',
      },
      cssStyle: {
        width: '765px !important',
      },
    },
    pos: {
      x: LEFT,
      y: 400,
    },
  },
];
page.word = [
  {
    id: 'page024_game2',
    icon: 'ikona_cw2',
    // tooltip: "Zaprogramuj animację (Scratch).",
    // tooltip: "page000_test24 TrInputOnBackgroundJims08",
    wordObj: {
      text: 'Uzupełnij zdania. Kliknij w ikonę programu Word.',
      audio: 'files/page024/z24c2.mp3',
      item: {
        path: 'informatyka/files/page024/24_ćw_2_word.docx',
      },
      cssStyle: {
        width: '765px !important',
      },
    },
    pos: {
      x: LEFT,
      y: 200,
    },
  },
];
page.games = [
  {
    id: 'page050_game10',
    icon: 'ikonaStepbystep',

    pos: {
      x: LEFT,
      y: 986,
    },
    item: {
      id: 'page050_game10',
    },
    rectangle: {
      id: 'page048_rect0',
    },
  },
  {
    id: 'page024_game1',
    tooltip: '',
    icon: 'ikona_cw1',
    pos: {
      x: LEFT,
      y: 0,
    },
  },
  // {
  //   id: 'page010_game2',
  //   tooltip: '',
  //   icon: 'ikona_cw2',
  //   pos: {
  //     x: LEFT,
  //     y: 200,
  //   },
  // },
  // {
  //   id: 'page019_game3',
  //   tooltip: '',
  //   icon: 'ikona_cw2',
  //   pos: {
  //     x: LEFT,
  //     y: 400,
  //   },
  // },
  // {
  //   id: 'page019_game4',
  //   tooltip: '',
  //   icon: 'ikona_cw2',
  //   pos: {
  //     x: LEFT,
  //     y: 600,
  //   },
  // },
  // {
  //   id: 'page010_game5',
  //   tooltip: '',
  //   icon: 'ikona_cw2',
  //   pos: {
  //     x: LEFT,
  //     y: 800,
  //   },
  // },
];
page.scratch = [
  {
    id: 'scratch1',
    icon: 'ikona_cw4',
    // tooltip: "Zaprogramuj animację (Scratch).",
    // tooltip: "page000_test24 TrInputOnBackgroundJims08",
    scratchObj: {
      text: 'Uruchom edytor Scratch. Kliknij w obrazek duszka-kota.',
      audio: 'files/page024/z24c4 - Stereo Out.mp3',
      item: {
        url: 'https://scratch.mit.edu/',
      },
      cssStyle: {
        width: '765px !important',
      },
    },
    pos: {
      x: LEFT,
      y: 600,
    },
  },
];
page.images = [
  {
    imageId: 'page048_zoom0',
    rectangle: {
      x: 130,
      y: 1308,
      width: 1646,
      height: 980,
    },
    imageSrc: 'images/page048/048 2.jpg',
  },
  {
    imageId: 'page048_zoom1',
    rectangle: {
      x: 612,
      y: 670,
      width: 1168,
      height: 600,
    },
    imageSrc: 'images/page048/048 1.jpg',
  },
];
page.rectangle = [
  {
    id: 'page048_rect0',

    tooltip: '',

    linked: ['page050_game10'],
    x: 120,
    y: 986,
    width: 433,
    height: 290,
  },
];
// page.games = [
//   {
//     id: 'page050_game10',
//     tooltip: '',
//     icon: 'ikonaNotatnik',
//     pos: {
//       x: RIGHT,
//       y: 200,
//     },
//   },
// {
//   id: 'page051_game11',
//   tooltip: '',
//   icon: 'ikonaNotatnik',
//   pos: {
//     x: RIGHT,
//     y: 200,
//   },
// },
// {
//   id: 'page051_game12',
//   tooltip: '',
//   icon: 'ikonaNotatnik',
//   pos: {
//     x: RIGHT,
//     y: 400,
//   },
// },
// {
//   id: 'page051_game13',
//   tooltip: '',
//   icon: 'ikonaNotatnik',
//   pos: {
//     x: RIGHT,
//     y: 600,
//   },
// },
// {
//   id: 'page051_game14',
//   tooltip: '',
//   icon: 'ikonaNotatnik',
//   pos: {
//     x: RIGHT,
//     y: 800,
//   },
// },
// ];
export default page;
